import { render, staticRenderFns } from "./fullpage-nav.vue?vue&type=template&id=1ac0ff2e&scoped=true"
import script from "./fullpage-nav.vue?vue&type=script&lang=js"
export * from "./fullpage-nav.vue?vue&type=script&lang=js"
import style0 from "./fullpage-nav.vue?vue&type=style&index=0&id=1ac0ff2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0ff2e",
  null
  
)

export default component.exports